<template>
  <div>
    <div class="loader" v-if="this.isLoading"></div>   
    <div class="loadertext" v-if="this.isLoading"> {{$t('loadingTxt')}}...</div>   
    <div class="main-wrapper" :class="{'blur-content': this.isLoading}">
        <!--begin::navbar-->
        <navbar-component></navbar-component>
        <!--end::navbar-->
 

      <div class="page-wrapper">

        <!--begin::content-->
        <div class="page-content">
          <div class="row">
            <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
              <div class="card">
                
                 <div class="card-header">
                  <!-- <i class="link-icon float-start" data-feather="arrow-left"></i> -->
                  &nbsp;&nbsp;&nbsp;
                  <h6 class="card-title mb-0 float-start" style="padding-left:25px"> {{ $t("salesSurvey") }} UPLOAD  </h6>
                   <button
                          class="btn btn-success btn-xs float-end"
                          @click="downloadTemplate"
                          type="button"
                        >
                        <i class="link-icon" data-feather="download"></i>
                          {{ $t("downloadData") }} Template
                        </button>

                </div>
                <div class="card-body">
              

                    <form
                        class="forms-sample"
                        @submit.prevent="submitData"
                        method="POST"
                        enctype="multipart/form-data"
                    >
                    
 
 
 
                    <div class="row mb-2">

                        <div class="col-lg-12">

                            <label for="defaultconfig" class="col-form-label required">File</label>
 
                            <input type="file" ref="file" class="form-control" :id="this.$dynamicId()" @change="handleFileUpload($event)" required />

                            <div v-if="errors.file">
                                <div v-for="error in errors.file" :key="error" class="alert alert-primary" role="alert">
                                    <i data-feather="alert-circle"></i> {{ error }}
                                </div>
                            </div>

                        </div>

                    
                        <div v-if="tableError">
                            <div class="col-lg-12">

                                    <br>
                                    <br>
                            
                                <div class="table-responsive">
                                    <table class="table table-hover">
                                        <thead>
                                        <th>{{ $t('lineNo') }}</th>
                                        <th>{{ $t('statusTxt') }}</th>
                                        <th>{{ $t('messageTxt') }}</th>
                                        </thead>
                                        <tbody>
                                        <tr v-for="(errorData, index) in errorsData" :key="index">
                                            <th>{{ errorData.lineNo }}</th>
                                            <th>{{ errorData.status }}</th>
                                            <th>{{ errorData.message }}</th>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
  
  
                        </div>


    

                    </div>

 








                   
                    <div class="card-footer">
                      <button
                        class="
                          btn btn-warning
                          text-black
                          fw-bolder
                          btn-icon-text
                        "
                        @click="backForm"
                        type="button"
                      >
                        <i class="link-icon" data-feather="arrow-left"></i>
                        {{ $t("backMess") }}
                      </button>

                  
                        &nbsp;&nbsp;&nbsp;
                        <button
                          class="btn btn-primary float-end btn-sm"
                          type="submit"
                        >
                          <i class="link-icon" data-feather="save"></i>
                          {{ $t("submitFormTxt") }}
                        </button>


                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::content-->

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>
  
  
<script>
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
 

export default {
    name: "SalesSurveyUpload2025",
    props: {},
    components: {

        "navbar-component": navbarComponent,
        "footer-component": footerComponent,

    },
    data() {
        const startDate = new Date();// new Date();
        const endDate = new Date();

        return {
        dateFilter: {
            startDate,
            endDate,
        },
        asnType: [],
        fetchAsnType: [],
        trackingOrderStatus: [],

        expectedShipmentTime1dateFilter: {
            startDate,
            endDate,
        },

        showModalNow: false,

        opens: "center",
        locale: {
            format: "yyyy-mm-dd H:MM:ss",
        },

        localeDetail: {
            format: "yyyy-mm-dd",
        },

        highlighted: {

            dates: [ // Highlight an array of dates
            new Date(),
            ],

        },

        digit: {
            decimal: ',',
            thousands: '.',
            prefix: ' ',
            suffix: '',
            precision: 5,
            masked: false
        },
        fetchStockCondition: [],
        detailAsn: [],
        orderType: '',
        fetchOrderType: [],
        shelfLifeUnit: {},
        shelfLifeType: {},
        permision_role: [],
        isLoading: false,
        maxToasts: 100,
        position: "up right",
        closeBtn: true,
        errors: [],
        userData: "",
        userRole: "",
        companyCode: "",
        fetchStatus: ['ACTIVE', 'DEACTIVE'],
        fetchmultiWhFlag: ['Y', 'N'],
        fetchCustomer: [],
        fetchFulfillment: [],
        customer: "",
        fulfillment: "",
        fetchShelfLifeType: [],
        fetchShelfLifeUnit: [],
        fetchSku: [],
        activeFlag: false,
        shelfLifeFlag: false,
        kitFlag: false,
        freePickGift: false,
        isLoadingStatus: false,
        tableError:false,
        file: '',
        errorsData:[],
        forms: {system_code_id:"", type:"", code:"", name:"", status:"", created_by:"", updated_by:"" , created_at:"", updated_at:""},
        };
    },
    watch: {},
    methods: {

        submitData() {
            this.$swal({
            title: this.$t("areYouSure"),
            text: this.$t("yourData"),
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes!",
            }).then((result) => {
                if (result.value) {
                    
                    this.isLoading = true;
        
                    let formData = new FormData();
                    formData.append("file", this.file);
                    formData.append('type',this.forms?.type);
                    const baseURI  =  this.$settings.endPointCeisa+"v1/sales-survey-2025/upload";
                    this.$http.post(baseURI,formData).then((response) => {
                        this.isLoading = false;
                        if(response.data.status === 200) {
                            this.errors = [];
                            this.tableError=true;
                            this.errorsData = response.data.datas;
                        }else{
                        
                            this.errors = response.data.errors;
                            this.resultError(response.data.errors);
                        }
                    }).catch((error) => {

                        this.isLoading = false;
                         this.tableError=true;

                        if (error.code == "ECONNABORTED") {
                            this.error(this.$t("check_internet_connection_txt"));

                        } else {


                            if (error.code == "ECONNABORTED") {
                                
                                this.error(this.$t("check_internet_connection_txt"));

                            } else {

                                if (error.response) {
                                    if (error.response.status === 422) {
                                        this.errorsData = error.response.data.errors;
                                        this.errors      = error.response.data.errors;
                                        this.resultError(error.response.data.errors);
                                    } else if (error.response.status === 401) {
                                    this.logout();
                                    } else if (error.response.status === 403) {
                                    this.$router.push("/authorized-error");
                                    } else if (error.response.status === 500) {
                                    this.$router.push('/server-error');
                                    } else {
                                    this.$router.push('/page-not-found');
                                    }
                                }

                            }

                        }

                    });
                }
            });
        },
   
        downloadTemplate() {
    
            const baseURI = this.$settings.endPointCeisa + "v1/sales-survey-2025/download-template";
    
            var file_name = "template_sales_survey.xlsx";
     
            this.isLoading = true;
            return this.$http.get(
                baseURI,
                {
                    responseType: "blob",
                }
            ).then((response) => {
            
                this.isLoading = false;
                var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                var fileLink = document.createElement("a");
    
                fileLink.href = fileURL;
                fileLink.setAttribute("download", file_name);
                document.body.appendChild(fileLink);
                fileLink.click();
                this.fade(false);
            }).catch((error) => {

                this.isLoading = false;

                if (error.code == "ECONNABORTED") {
                    this.error(this.$t("check_internet_connection_txt"));

                } else {


                    if (error.code == "ECONNABORTED") {
                        
                        this.error(this.$t("check_internet_connection_txt"));

                    } else {

                        if (error.response) {
                            if (error.response.status === 422) {
                            this.errors = error.response.data.errors;
                            this.resultError(error.response.data.errors);
                            } else if (error.response.status === 401) {
                            this.logout();
                            } else if (error.response.status === 403) {
                            this.$router.push("/authorized-error");
                            } else if (error.response.status === 500) {
                            this.$router.push('/server-error');
                            } else {
                            this.$router.push('/page-not-found');
                            }
                        }

                    }

                }

            });

        },

        handleFileUpload( event ){
            this.file = event.target.files[0];
        },


        fetchIt() {
            const userDatas = this.$getUserInfo();
            this.userData = userDatas.sub;
            this.userRole = userDatas.sub.role;
            // this.permision_role = userDatas.sub.permision_role;
            let rolePermision = [];
            userDatas.sub.permision_role.forEach(function (permision) {
                if (permision.permission.controller == 'SalesSurveyV2Controller') {
                    rolePermision = permision;
                }
            });

            if (!rolePermision.method_upload) {
                this.$router.push("/authorized-error");
            }

            this.permision_role = rolePermision;

        },

        backForm() {
            window.location.href = "/sales-survey/v2";
        },

        logout() {

            const baseURI = this.$settings.endPoint + "user/logout";
            this.$http.get(baseURI, { timeout: 10000 }).then((response) => {

                console.log(response);

            });

            this.$logoutUser();
            window.location.href = '/';
        },

        fade(sType) {
            this.isLoading = sType;
        },

        loading() {
            this.fade(true);
            setTimeout(() => {
                this.fade(false);
            }, 1000); // hide the message after 3 seconds
        },

        resultError(data) {
            var count = Object.keys(data).length;
            for (var x = 0; x < count; x++) {
                var nameOb = Object.keys(data)[x];
                var objectData = data[nameOb];
                for (var y = 0; y < objectData.length; y++) {
                    this.error(objectData[y]);
                }
            }
        },

        success(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "success",
                title: kata,
            });
        },

        error(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "error",
                title: kata,
            });
        },


        cek_message(status,msg){
            if(status=='200'){
                this.success(msg);
            }
        },

    },
    events: {},
    created: function () { },
    mounted() {

        this.fetchIt();
        this.cek_message(this.$route.query.status,this.$route.query.msg);


    },
};
</script>
<style scoped>.required:after {
  content: " *";
  color: red;
}</style>